import Immutable from "immutable";

/**
 *
 * @param selectedCartItemData
 * @param context
 *
 * @returns {*}
 */
export const getSelectedCartItemTitleFromContext = (selectedCartItemData, context) =>
  (context || Immutable.Map())
    .get("itemContexts", Immutable.List())
    .find(c => c.get("webProductId") === selectedCartItemData.webProductId, null, Immutable.Map())
    .get("items", Immutable.List())
    .find(pcm => pcm.get("id") === selectedCartItemData.productCollectionMemberId, null, Immutable.Map())
    .get("title", "???");

/**
 *
 * @param cart
 *
 * @returns {*}
 */
export const getContextFromCart = cart => {
  const ctx = Immutable.Map({
    webProductId: cart.get("webProductId"),
    items: cart.get("items", Immutable.List()),
    type: cart.getIn(["customer", "type"]),
    countryCode: cart.getIn(["customer", "countryCode"]),
    zipcode: cart.getIn(["customer", "zipcode"]),
    emailAddress: cart.getIn(["customer", "emailAddress"]),
    recipients: cart.get("recipients").map(r =>
      Immutable.Map({
        products: r.get("products"),
        countryCode: r.getIn(["address", "countryCode"]),
        zipcode: r.getIn(["address", "zipcode"]),
        streetNumber: r.getIn(["address", "streetNumber"]),
        addressType: r.getIn(["address", "addressType"]) === 'company' ? 'company' : '',
        date: r.getIn(["delivery", "date"]),
        timeFrame: r.getIn(["delivery", "timeFrame"]),
        cardType: r.getIn(["card", "type"])
      })
    ),
    paymentType: cart.getIn(["checkout", "payment", "type"]),
    discountCode: cart.getIn(["checkout", "payment", "discountCode"], "")
  });

  if (ctx.get("discountCode") !== "") {
    return ctx;
  }

  return (
    ctx
      // remove email from context influence as is only required when a discountCode is set!
      .delete("emailAddress")
      // remove quan-titties from context influence as is only required when a discountCode is set!
      .set("items", ctx.get("items", Immutable.List()).map(i => i.delete("quantity")))
  );
};

export const hasContextInfluencingCartStuff = (cart1, cart2) => {
  if (!cart1 || !cart2) {
    return false;
  }
  const result = !getContextFromCart(Immutable.fromJS(cart1)).equals(getContextFromCart(Immutable.fromJS(cart2)));

  if (__DEV__ && __DEBUG__) {
    // eslint-disable-next-line no-console
    console.log("hasContextInfluencingCartStuff", cart1, cart2);
    // eslint-disable-next-line no-console
    console.log("hasContextInfluencingCartStuff", result);
  }
  return result;
};

export default {};
